import SpinIcon from '../assets/spin.svg';

/**
 * Loader component for full screen
 * @returns JSX.Element
 */
const FullSizeLoader = (): JSX.Element => {
    return <img alt='spin-icon' className='position-absolute' style={{ zIndex: 100 }} src={SpinIcon}></img>;
};

export default FullSizeLoader;
